/*
 * Hook de chargement des statistiques du tunnel admin.
 * Compteurs agreges et anonymes uniquement : aucune donnee de sante.
 */

import { useCallback, useEffect, useState } from "react";
import { adminGetFunnel } from "@/lib/api";

export function useFunnelStats(adminKey) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [period, setPeriod] = useState("all");

  const load = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const stats = await adminGetFunnel(adminKey, period);
      setData(stats);
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [adminKey, period]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, period, setPeriod, reload: load };
}
